<div class="main-content table-page planeacion-bsc">
  <div class="container-fluid">
    <nav class="bsc-migas" aria-label="Ruta de navegación">
      <a [routerLink]="ruta.tablero" [queryParams]="queryTablero">Tablero BSC</a>
      <span aria-hidden="true">›</span>
      <span aria-current="page">Planeación {{ anio ?? "" }}</span>
    </nav>

    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1 id="bsc-plan-titulo" tabindex="-1">{{ titulo }}</h1>
        <p>{{ resumenHero }}</p>
        <div class="planeacion-bsc__sellos" *ngIf="estado === 'PLANEACION' && estadoPlaneacion as e">
          <span class="table-page__status-badge" [ngClass]="e.clase">
            <span class="material-icons" aria-hidden="true">{{ e.icono }}</span>
            {{ e.texto }}{{ ejercicioOrigen?.anio ? " · a partir de " + ejercicioOrigen?.anio : "" }}
          </span>
          <span class="planeacion-bsc__candado" *ngIf="!editable">
            <span class="material-icons" aria-hidden="true">lock</span>
            {{ textoCandado }}
          </span>
        </div>
      </div>

      <div class="table-page__toolbar-actions planeacion-bsc__acciones">
        <ng-container *ngIf="editable">
          <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" *ngIf="puedeCargar"
             [routerLink]="ruta.cargaExcel" [queryParams]="queryCargaExcel">
            <span class="material-icons" aria-hidden="true">upload_file</span>
            Cargar desde Excel
          </a>
          <button type="button" id="bsc-plan-agregar" mat-raised-button
                  class="btn table-page__icon-btn table-page__icon-btn--secondary" [disabled]="ocupado" (click)="agregarKpi()">
            <span class="material-icons" aria-hidden="true">add</span>
            Agregar KPI
          </button>
          <button type="button" id="bsc-plan-guardar" mat-raised-button
                  class="btn table-page__icon-btn table-page__icon-btn--secondary" [disabled]="ocupado || !sucio"
                  [attr.aria-busy]="guardando" (click)="guardar()">
            <span class="material-icons" aria-hidden="true">{{ guardando ? "hourglass_top" : "save" }}</span>
            {{ guardando ? "Guardando…" : "Guardar borrador" }}
          </button>
          <button type="button" id="bsc-plan-enviar" mat-raised-button class="btn table-page__primary-btn"
                  [disabled]="!puedeEnviar" [attr.aria-busy]="enviando"
                  [attr.aria-describedby]="razonNoEnvio ? 'bsc-plan-razon' : null" (click)="enviar()">
            <span class="material-icons" aria-hidden="true">{{ enviando ? "hourglass_top" : "send" }}</span>
            {{ enviando ? "Enviando…" : "Enviar a autorización" }}
          </button>
        </ng-container>

        <ng-container *ngIf="puedeResolver">
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                  [disabled]="ocupado" (click)="resolver(false)">
            <span class="material-icons" aria-hidden="true">undo</span>
            Regresar
          </button>
          <button type="button" mat-raised-button class="btn table-page__primary-btn" [disabled]="ocupado"
                  (click)="resolver(true)">
            <span class="material-icons" aria-hidden="true">verified</span>
            Autorizar
          </button>
        </ng-container>
      </div>
    </section>

    <app-selector-corte-bsc prefijo="bsc-planeacion" [mostrarCorte]="false" [incluirSiguiente]="true" [anio]="anioInicial"
                            [deshabilitado]="ocupado" (cargado)="onCatalogos($event)" (cambio)="onSeleccion($event)">
      <div meta class="tickets-filter planeacion-bsc__filtro-area" *ngIf="opcionesArea.length > 0">
        <label for="bsc-planeacion-area">Área</label>
        <div class="tickets-select">
          <mat-icon aria-hidden="true">groups</mat-icon>
          <select #comboArea id="bsc-planeacion-area" [disabled]="ocupado" (change)="cambiaArea($event)">
            <option *ngFor="let a of opcionesArea" [value]="a.idBscArea" [selected]="a.idBscArea === idBscArea">
              {{ a.nombre }}
            </option>
          </select>
        </div>
      </div>
      <div meta class="tickets-toolbar__meta" *ngIf="estado === 'PLANEACION'">
        <span>{{ conservadas }} {{ conservadas === 1 ? "KPI" : "KPIs" }} en la planeación</span>
        <strong>{{ sucio ? "Cambios sin guardar" : editable ? "Todo guardado" : "Solo lectura" }}</strong>
      </div>
    </app-selector-corte-bsc>

    <output class="bsc-franja" *ngIf="avisoArea">
      <span class="material-icons" aria-hidden="true">info</span>
      <span>{{ avisoArea }}</span>
    </output>

    <!-- ============================ Estados sin tabla ============================ -->
    <section class="table-page__card" *ngIf="estado === 'CARGANDO'">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">hourglass_top</span>
        <h3>Consultando la planeación</h3>
        <p>Espere un momento.</p>
      </div>
    </section>

    <section class="table-page__card" *ngIf="estado === 'SIN_CATALOGOS'">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">cloud_off</span>
        <h3>No se pudieron leer las áreas del BSC</h3>
        <p>Sin ellas no se sabe qué planeación abrir.</p>
        <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="recargarCatalogos()">
          <span class="material-icons" aria-hidden="true">refresh</span>
          Reintentar
        </button>
      </div>
    </section>

    <section class="table-page__card" *ngIf="estado === 'SIN_AREAS'">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">groups</span>
        <h3>No tienes áreas que planear</h3>
        <p>Calidad asigna a cada área su responsable y capturistas en Parámetros.</p>
        <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" *ngIf="puedeConfigurar"
           [routerLink]="ruta.parametros">
          <span class="material-icons" aria-hidden="true">tune</span>
          Ir a Parámetros
        </a>
      </div>
    </section>

    <section class="table-page__card" *ngIf="estado === 'ERROR'">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">lock_outline</span>
        <h3>No se pudo consultar la planeación</h3>
        <p>{{ error }}</p>
        <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="consultar()">
          <span class="material-icons" aria-hidden="true">refresh</span>
          Volver a consultar
        </button>
      </div>
    </section>

    <!-- Avisos del servidor: año sin ciclo, área sin responsable, KPI que no se copió… -->
    <section class="table-page__card bsc-bloque"
             *ngIf="avisos.length > 0 && (estado === 'SIN_CICLO' || estado === 'SIN_PLANEACION' || estado === 'PLANEACION')">
      <div class="bsc-mensajes bsc-mensajes--aviso">
        <h3>
          <span class="material-icons" aria-hidden="true">warning_amber</span>
          Para revisar ({{ avisos.length }})
        </h3>
        <ul>
          <li *ngFor="let a of avisos; trackBy: trackMensaje" [attr.title]="a.codigo || null">{{ a.texto }}</li>
        </ul>
      </div>
    </section>

    <section class="table-page__card" *ngIf="estado === 'SIN_CICLO'">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">event_busy</span>
        <h3>{{ anio }} todavía no está dado de alta en el BSC</h3>
        <p>Calidad lo abre en Parámetros (umbral, semáforo y fechas del ciclo) antes de planear las metas.</p>
        <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" *ngIf="puedeConfigurar"
           [routerLink]="ruta.parametros">
          <span class="material-icons" aria-hidden="true">tune</span>
          Configurar {{ anio }}
        </a>
      </div>
    </section>

    <section class="table-page__card bsc-bloque" *ngIf="estado === 'SIN_PLANEACION'" aria-labelledby="bsc-plan-abrir">
      <header class="bsc-bloque__encabezado">
        <h2 id="bsc-plan-abrir">{{ nombreArea }} todavía no tiene planeación {{ anio }}</h2>
        <p *ngIf="puedeAbrir">
          Se abre en borrador: se ajusta aquí y se envía a autorización. Hasta que Dirección la autorice no se capturan
          avances.
        </p>
        <p *ngIf="!puedeAbrir && anio != null && anio < anioEnCurso">
          La planeación se abre para {{ anioEnCurso }} o un año siguiente; un año pasado se carga con su FOR-011 en modo
          Histórico.
        </p>
        <p *ngIf="!puedeAbrir && cicloCerrado">{{ anio }} está cerrado: ya no se le abre planeación.</p>
        <p *ngIf="!puedeAbrir && !cicloCerrado && anio != null && anio >= anioEnCurso && !puedePlanear">
          Tu perfil no puede abrir la planeación de esta área.
        </p>
      </header>

      <div class="planeacion-bsc__abrir" *ngIf="puedeAbrir">
        <article class="planeacion-bsc__opcion" *ngIf="ejercicioOrigen">
          <h3>Crear a partir de {{ ejercicioOrigen.anio }}</h3>
          <p>
            Se copian los {{ kpisOrigen.length }} KPI activos de la planeación autorizada {{ ejercicioOrigen.anio }} con
            su meta, unidad, pesos y NA; al enviar se pide el motivo de cada meta que cambie.
          </p>
          <ul class="planeacion-bsc__lista-origen" *ngIf="kpisOrigen.length > 0">
            <li *ngFor="let o of kpisOrigen">
              <span>{{ o.objetivo }}</span>
              <span class="table-page__subtext" *ngIf="o.metaValor != null || o.metaTexto">
                Meta {{ ejercicioOrigen.anio }}: {{ textoMetaOrigen(o) }}
              </span>
            </li>
          </ul>
          <button type="button" mat-raised-button class="btn table-page__primary-btn" [disabled]="ocupado"
                  [attr.aria-busy]="creando" (click)="crear(true)">
            <span class="material-icons" aria-hidden="true">{{ creando ? "hourglass_top" : "content_copy" }}</span>
            {{ creando ? "Creando…" : "Crear a partir de " + ejercicioOrigen.anio }}
          </button>
        </article>

        <article class="planeacion-bsc__opcion">
          <h3>Empezar vacía</h3>
          <p>Para un área nueva o un año que no sigue al anterior: los KPIs se agregan uno por uno.</p>
          <button type="button" mat-raised-button class="btn"
                  [ngClass]="ejercicioOrigen ? 'table-page__icon-btn table-page__icon-btn--secondary' : 'table-page__primary-btn'"
                  [disabled]="ocupado" (click)="crear(false)">
            <span class="material-icons" aria-hidden="true">note_add</span>
            Empezar vacía
          </button>
        </article>

        <article class="planeacion-bsc__opcion" *ngIf="puedeCargar">
          <h3>Cargar el FOR-011</h3>
          <p>El Excel del área en modo Planeación: metas, unidades, pesos y NA; la planeación queda en borrador aquí.</p>
          <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
             [routerLink]="ruta.cargaExcel" [queryParams]="queryCargaExcel">
            <span class="material-icons" aria-hidden="true">upload_file</span>
            Cargar desde Excel
          </a>
        </article>
      </div>
    </section>

    <!-- ============================ La planeación ============================ -->
    <ng-container *ngIf="estado === 'PLANEACION'">
      <output class="bsc-franja planeacion-bsc__franja" *ngIf="estatus === 'REGRESADA' && regreso">
        <span class="material-icons" aria-hidden="true">undo</span>
        <span>
          Regresada por {{ regreso.quien }} el {{ regreso.cuando }}{{ regreso.detalle ? ": " + regreso.detalle : "." }}
          Corrígela y vuelve a enviarla.
        </span>
      </output>

      <output class="bsc-franja planeacion-bsc__franja" *ngIf="estatus === 'ENVIADA'">
        <span class="material-icons" aria-hidden="true">send</span>
        <span>
          Enviada a autorización{{ envio ? " por " + envio.quien + " el " + envio.cuando : "" }}.
          <ng-container *ngIf="puedeResolver">
            Revisa las metas: autorízala con tu PIN o regrésala con un comentario.
            <ng-container *ngIf="!tienePin"> Aún no defines tu PIN: se define una sola vez en Ajustes.</ng-container>
          </ng-container>
          <ng-container *ngIf="!puedeResolver">Dirección la revisa; mientras, no se edita.</ng-container>
        </span>
      </output>

      <output class="bsc-franja planeacion-bsc__franja" *ngIf="estatus === 'AUTORIZADA'">
        <span class="material-icons" aria-hidden="true">verified</span>
        <span>
          {{ autorizacion ? "Autorizada por " + autorizacion.quien + " el " + autorizacion.cuando + "." : "Autorizada." }}
          Metas, pesos y NA quedan fijos todo {{ anio }}; un cambio de meta solo se hace al planear el año siguiente.
        </span>
      </output>

      <!-- Lo que impide enviar (servidor, sobre lo guardado). -->
      <section class="table-page__card bsc-bloque" *ngIf="editable && faltantes.length > 0">
        <div class="bsc-mensajes bsc-mensajes--error">
          <h3>
            <span class="material-icons" aria-hidden="true">block</span>
            Lo que impide enviar ({{ faltantes.length }})
          </h3>
          <p class="bsc-nota" *ngIf="sucio">Según lo guardado: guarda el borrador para que se vuelva a revisar.</p>
          <ul>
            <li *ngFor="let m of faltantes; trackBy: trackMensaje" [attr.title]="m.codigo || null">{{ m.texto }}</li>
          </ul>
        </div>
      </section>

      <section class="table-page__card bsc-bloque" aria-labelledby="bsc-plan-tabla-titulo">
        <header class="bsc-bloque__encabezado">
          <h2 id="bsc-plan-tabla-titulo">Metas y pesos {{ anio }}</h2>
          <p *ngIf="editable">
            La meta se escribe como en el FOR-011 («95%», «6 productos», «12 días»); los pesos de cada trimestre en %, y
            deben sumar 100 % entre los trimestres que aplican. NA = el KPI no aplica en ese trimestre.
          </p>
          <p *ngIf="!editable">Metas, unidades y pesos como quedaron en la planeación.</p>
        </header>

        <div class="table-page__table-wrap planeacion-bsc__tabla-wrap" *ngIf="filas.length > 0; else sinKpis">
          <table class="table-page__table planeacion-bsc__tabla" [class.is-lectura]="!editable">
            <caption class="bsc-oculto">Metas y pesos {{ anio }} de {{ nombreArea }}</caption>
            <thead>
              <tr>
                <th class="planeacion-bsc__col-casilla" *ngIf="editable">
                  <mat-checkbox [checked]="todasConservadas" [indeterminate]="algunaConservada && !todasConservadas"
                                [disabled]="ocupado || !hayExistentes" (change)="conservaTodas($event.checked)"
                                aria-label="Conservar todos los KPI que ya están en la planeación"></mat-checkbox>
                </th>
                <th class="planeacion-bsc__col-objetivo">KPI</th>
                <th class="planeacion-bsc__num planeacion-bsc__col-origen" *ngIf="ejercicioOrigen">
                  {{ ejercicioOrigen.anio }}<span class="planeacion-bsc__th-sub">meta · alcance</span>
                </th>
                <th class="planeacion-bsc__num planeacion-bsc__col-meta">
                  Meta {{ anio }}<span class="planeacion-bsc__th-sub">y unidad</span>
                </th>
                <th class="planeacion-bsc__num planeacion-bsc__col-q" *ngFor="let q of trimestres">Q{{ q }}</th>
                <th class="planeacion-bsc__num planeacion-bsc__col-suma">Suma</th>
                <th class="planeacion-bsc__col-motivo">Motivo del cambio</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let f of filas; let i = index; trackBy: trackFila" [attr.data-clave]="f.clave"
                  [class.is-quitada]="!f.conservar"
                  [class.is-error]="editable && f.conservar && (f.pesosConError || f.motivoPendiente)"
                  [class.is-cambio]="f.conservar && (editable ? !f.pesosConError && !f.motivoPendiente && f.metaCambiada : f.metaCambiada || f.pesosCambiados)">

                <!-- Conservar / quitar -->
                <td class="planeacion-bsc__col-casilla" *ngIf="editable">
                  <mat-checkbox *ngIf="!f.nueva" [checked]="f.conservar" [disabled]="ocupado"
                                (change)="conservaFila(f, $event.checked)"
                                [aria-label]="'Conservar ' + f.nombre"></mat-checkbox>
                  <button type="button" class="table-page__action-btn table-page__action-btn--danger" *ngIf="f.nueva"
                          title="Quitar" [attr.aria-label]="'Quitar de la lista: ' + f.nombre" [disabled]="ocupado"
                          (click)="quitarNueva(f)">
                    <span class="material-icons" aria-hidden="true">close</span>
                  </button>
                </td>

                <!-- KPI -->
                <td class="planeacion-bsc__col-objetivo">
                  <ng-container *ngIf="!f.nueva || !editable; else kpiNuevo">
                    <div class="table-page__cell-stack">
                      <strong class="table-page__name">{{ f.objetivo || "(sin objetivo)" }}</strong>
                      <span class="table-page__subtext" *ngIf="f.indicador">{{ f.indicador }}</span>
                      <span class="table-page__subtext planeacion-bsc__quitado" *ngIf="!f.conservar">{{ editable ? "Se quita de" : "Quitado de" }} {{ anio }}</span>
                      <ul class="planeacion-bsc__avisos-fila" *ngIf="editable && !f.editada && f.avisos.length > 0">
                        <li *ngFor="let a of f.avisos; trackBy: trackMensaje" [attr.title]="a.codigo || null">{{ a.texto }}</li>
                      </ul>
                    </div>
                  </ng-container>
                  <ng-template #kpiNuevo>
                    <div class="planeacion-bsc__kpi-nuevo">
                      <mat-form-field appearance="outline" class="table-page__field planeacion-bsc__celda"
                                      subscriptSizing="dynamic" *ngIf="candidatosOrigen.length > 0">
                        <mat-select [id]="'bsc-plan-origen-' + f.clave" [ngModel]="f.idKpi" [disabled]="ocupado"
                                    (ngModelChange)="eligeOrigen(f, $event)" aria-label="Qué KPI se agrega">
                          <mat-option [value]="null">KPI nuevo</mat-option>
                          <mat-option *ngFor="let c of candidatosOrigen" [value]="c.idKpi">
                            {{ c.objetivo }} (de {{ ejercicioOrigen?.anio }})
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <ng-container *ngIf="f.idKpi == null; else delOrigen">
                        <mat-form-field appearance="outline" class="table-page__field planeacion-bsc__celda"
                                        subscriptSizing="dynamic">
                          <input matInput [id]="'bsc-plan-objetivo-' + f.clave" [maxlength]="largoObjetivo" required
                                 [ngModel]="f.objetivo" (ngModelChange)="f.objetivo = $event; nombreDe(f)"
                                 [disabled]="ocupado" placeholder="Objetivo del KPI nuevo"
                                 aria-label="Objetivo del KPI nuevo" />
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="table-page__field planeacion-bsc__celda"
                                        subscriptSizing="dynamic">
                          <input matInput [maxlength]="largoObjetivo" [ngModel]="f.indicador"
                                 (ngModelChange)="f.indicador = $event; recalcula(f)" [disabled]="ocupado"
                                 placeholder="Indicador (cómo se mide)"
                                 [attr.aria-label]="'Indicador de ' + f.nombre" />
                        </mat-form-field>
                      </ng-container>
                      <ng-template #delOrigen>
                        <span class="table-page__subtext" *ngIf="f.indicador">{{ f.indicador }}</span>
                      </ng-template>
                      <span class="table-page__subtext">Se agrega a {{ anio }} al guardar.</span>
                    </div>
                  </ng-template>
                </td>

                <!-- El año de origen: meta y alcance (la L del último trimestre con datos) -->
                <td class="planeacion-bsc__num planeacion-bsc__col-origen" *ngIf="ejercicioOrigen">
                  <div class="table-page__cell-stack">
                    <span class="table-page__text planeacion-bsc__apagado">{{ f.metaAnterior }}</span>
                    <span class="table-page__subtext" *ngIf="f.origen">Alcance {{ f.alcanceAnterior }}</span>
                  </div>
                </td>

                <!-- Meta y unidad -->
                <td class="planeacion-bsc__num planeacion-bsc__col-meta">
                  <ng-container *ngIf="editable; else metaLectura">
                    <mat-form-field appearance="outline" class="table-page__field planeacion-bsc__celda"
                                    subscriptSizing="dynamic">
                      <input matInput class="planeacion-bsc__input-num" [maxlength]="largoMeta" [ngModel]="f.metaEscrita"
                             (ngModelChange)="cambiaMeta(f, $event)" [disabled]="ocupado || !f.conservar"
                             placeholder="p. ej. 95%" [attr.aria-label]="'Meta ' + anio + ' de ' + f.nombre" />
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="table-page__field planeacion-bsc__celda planeacion-bsc__unidad"
                                    subscriptSizing="dynamic">
                      <mat-select [ngModel]="f.unidad" (ngModelChange)="f.unidad = $event; recalcula(f)"
                                  [disabled]="ocupado || !f.conservar" [aria-label]="'Unidad de la meta de ' + f.nombre">
                        <mat-option *ngFor="let u of opcionesUnidad" [value]="u.valor">{{ u.texto }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-container>
                  <ng-template #metaLectura>
                    <div class="table-page__cell-stack">
                      <span class="table-page__text">{{ f.metaEscrita || "—" }}</span>
                      <span class="table-page__subtext">{{ f.unidad === "dias" ? "días" : f.unidad }}</span>
                    </div>
                  </ng-template>
                </td>

                <!-- Pesos Q1..Q4 con NA -->
                <td class="planeacion-bsc__num planeacion-bsc__col-q" *ngFor="let q of trimestres; let j = index"
                    [class.is-na]="f.na[j]">
                  <ng-container *ngIf="editable; else pesoLectura">
                    <mat-form-field appearance="outline" class="table-page__field planeacion-bsc__celda"
                                    subscriptSizing="dynamic">
                      <input matInput type="number" inputmode="decimal" min="0" max="100" step="0.1"
                             class="planeacion-bsc__input-num" [ngModel]="f.pesos[j]"
                             (ngModelChange)="f.pesos[j] = $event; recalcula(f)" [disabled]="ocupado || !f.conservar"
                             [attr.aria-label]="'Peso Q' + q + ' (%) de ' + f.nombre + (f.na[j] ? ', no aplica' : '')"
                             [attr.aria-describedby]="'bsc-plan-suma-' + f.clave" />
                    </mat-form-field>
                    <mat-checkbox class="planeacion-bsc__na" [checked]="f.na[j]" [disabled]="ocupado || !f.conservar"
                                  (change)="alternaNa(f, j, $event.checked)"
                                  [aria-label]="'NA en Q' + q + ': ' + f.nombre + ' no aplica en ese trimestre'">NA</mat-checkbox>
                  </ng-container>
                  <ng-template #pesoLectura>
                    <span class="table-page__text">{{ f.na[j] ? "NA" : (f.pesos[j] ?? 0) + "%" }}</span>
                  </ng-template>
                </td>

                <!-- Suma (previa; el servidor decide al enviar) -->
                <td class="planeacion-bsc__num">
                  <div class="table-page__cell-stack" [id]="'bsc-plan-suma-' + f.clave">
                    <span class="planeacion-bsc__suma" [ngClass]="f.sumaClase">{{ f.suma }}</span>
                    <span class="table-page__subtext" *ngIf="f.sumaNota">{{ f.sumaNota }}</span>
                  </div>
                </td>

                <!-- Motivo -->
                <td class="planeacion-bsc__col-motivo">
                  <ng-container *ngIf="editable && f.conMotivo && f.conservar; else motivoTexto">
                    <mat-form-field appearance="outline" class="table-page__field planeacion-bsc__celda" subscriptSizing="dynamic">
                      <input matInput [maxlength]="largoMotivo" [required]="f.metaCambiada" [ngModel]="f.motivo"
                             (ngModelChange)="f.motivo = $event; recalcula(f)" [disabled]="ocupado"
                             [placeholder]="f.metaCambiada ? 'Por qué cambia la meta' : 'Opcional'"
                             [attr.aria-label]="'Motivo del cambio de ' + f.nombre"
                             [attr.aria-describedby]="'bsc-plan-motivo-' + f.clave" />
                    </mat-form-field>
                    <span class="table-page__subtext" [id]="'bsc-plan-motivo-' + f.clave"
                          [class.planeacion-bsc__pendiente]="f.motivoPendiente">
                      {{ f.motivoPendiente ? "Obligatorio: la meta cambió frente a " + ejercicioOrigen?.anio + "." : "" }}
                      {{ f.pesosCambiados ? "Pesos " + ejercicioOrigen?.anio + ": " + f.pesosAnteriores + "." : "" }}
                    </span>
                  </ng-container>
                  <!-- Solo lectura (ENVIADA/AUTORIZADA, o sin poder editar): lo que cambió frente al origen
                       se dice aunque no traiga motivo (el servidor solo lo pide si cambia la meta). -->
                  <ng-template #motivoTexto>
                    <div class="table-page__cell-stack">
                      <span class="table-page__text" *ngIf="f.motivo">{{ f.motivo }}</span>
                      <ng-container *ngIf="f.conservar && f.origen; else sinOrigen">
                        <span class="table-page__subtext" *ngIf="f.metaCambiada">
                          Meta {{ ejercicioOrigen?.anio }}: {{ f.metaAnterior }}.
                        </span>
                        <span class="table-page__subtext" *ngIf="f.pesosCambiados">
                          Pesos {{ ejercicioOrigen?.anio }}: {{ f.pesosAnteriores }}.
                        </span>
                        <span class="table-page__subtext" *ngIf="!f.motivo && !f.metaCambiada && !f.pesosCambiados">
                          Sin cambio
                        </span>
                      </ng-container>
                      <ng-template #sinOrigen>
                        <span class="table-page__subtext" *ngIf="!f.motivo">
                          {{ f.conservar && ejercicioOrigen ? "KPI nuevo" : "—" }}
                        </span>
                      </ng-template>
                    </div>
                  </ng-template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <ng-template #sinKpis>
          <div class="table-page__empty planeacion-bsc__vacio">
            <span class="material-icons" aria-hidden="true">playlist_add</span>
            <h3>La planeación no tiene KPIs</h3>
            <p *ngIf="editable">Agrégalos con «Agregar KPI» o cárgalos del FOR-011.</p>
          </div>
        </ng-template>

        <!-- El ciclo (lo fija Calidad) y la previa de lo que falta. -->
        <footer class="planeacion-bsc__pie">
          <dl class="planeacion-bsc__ciclo">
            <div>
              <dt>Umbral gerencial {{ anio }} (objetivo Solser)</dt>
              <dd>{{ objetivoSolser || "—" }} <span class="planeacion-bsc__dd-sub">· lo fija Calidad en Parámetros</span></dd>
            </div>
            <div>
              <dt>Fechas del ciclo (las fija Calidad)</dt>
              <dd>{{ fechasCiclo || "Sin fechas" }}</dd>
            </div>
            <div>
              <dt>Autoriza</dt>
              <dd>
                Dirección, con su PIN. Al autorizar, metas y pesos se bloquean y {{ anio }} queda listo para captura desde
                enero.
              </dd>
            </div>
          </dl>
          <div class="planeacion-bsc__estado" *ngIf="editable">
            <output aria-live="polite" [class.is-error]="filasConPesosMal > 0 || motivosPendientes > 0">
              <ng-container *ngIf="filasConPesosMal > 0">
                {{ filasConPesosMal === 1 ? "1 fila con pesos que no suman 100 %" : filasConPesosMal + " filas con pesos que no suman 100 %" }}.
              </ng-container>
              <ng-container *ngIf="motivosPendientes > 0">
                {{ motivosPendientes === 1 ? "1 meta cambiada sin motivo" : motivosPendientes + " metas cambiadas sin motivo" }}.
              </ng-container>
              <ng-container *ngIf="filasConPesosMal === 0 && motivosPendientes === 0">Pesos y motivos en orden (vista previa).</ng-container>
            </output>
            <p class="bsc-nota" id="bsc-plan-razon" *ngIf="razonNoEnvio">{{ razonNoEnvio }}</p>
            <button type="button" class="planeacion-bsc__enlace" *ngIf="sucio" [disabled]="ocupado" (click)="descartar()">
              <span class="material-icons" aria-hidden="true">restart_alt</span>
              Descartar cambios
            </button>
          </div>
        </footer>
      </section>

      <!-- ============================ Bitácora ============================ -->
      <section class="table-page__card bsc-bloque" *ngIf="movimientos.length > 0" aria-labelledby="bsc-plan-bitacora">
        <header class="bsc-bloque__encabezado">
          <h2 id="bsc-plan-bitacora">Bitácora de la planeación</h2>
          <p>Quién la envió, la autorizó o la regresó, y cada cambio de meta frente al año de origen.</p>
        </header>
        <ol class="planeacion-bsc__bitacora">
          <li *ngFor="let m of movimientos; trackBy: trackMovimiento">
            <span class="planeacion-bsc__bitacora-cuando">{{ m.cuando }}</span>
            <span>
              <strong>{{ m.accion }}</strong> · {{ m.quien }}
              <span class="planeacion-bsc__bitacora-detalle" *ngIf="m.detalle">{{ m.detalle }}</span>
            </span>
          </li>
        </ol>
      </section>
    </ng-container>
  </div>
</div>
